/**
 * Section repliable de l'onglet Import et paramètres, et bandeau de synthèse
 * de l'onglet Roadbook — EF-NAV-001, EF-RBK-008.
 */

import type { ComponentChildren, JSX } from 'preact';
import { Glyph } from '../icons';
import { openDisclosures, toggleDisclosure } from '../state';

export interface DisclosureProps {
  readonly title: string;
  /** Résumé affiché sur la ligne repliée, à droite du titre. */
  readonly hint?: string | undefined;
  /** Identifiant stable de la section, pour la persistance du plié/déplié. */
  readonly id: string;
  readonly children: ComponentChildren;
}

export function Disclosure(props: DisclosureProps): JSX.Element {
  const open = openDisclosures.value.has(props.id);

  return (
    <section class="disclosure">
      <button
        type="button"
        class="disclosure__summary"
        aria-expanded={open}
        aria-controls={props.id}
        onClick={() => {
          toggleDisclosure(props.id);
        }}
      >
        <span class="disclosure__title">{props.title}</span>
        {props.hint !== undefined ? <span class="disclosure__hint">{props.hint}</span> : null}
        <span class={open ? 'disclosure__chevron disclosure__chevron--open' : 'disclosure__chevron'}>
          <Glyph name="deplier" label="" size={22} decorative />
        </span>
      </button>
      {open ? (
        <div class="disclosure__body" id={props.id}>
          {props.children}
        </div>
      ) : null}
    </section>
  );
}
